<!--
 * @Author: ldx
 * @Date: 2022-10-14 09:31:48
 * @LastEditors: ldx
 * @LastEditTime: 2023-03-29 16:48:04
 * @Description:  协议
-->
<template>
  <router-view></router-view>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped></style>
